import React from "react";
import styles from "./annoncesLpHeader.module.css";
import Image from "next/image";

function index(props) {
  return (
    <div
      className={`${!props.isHeaderBlocks && !props.agenceImmo
          ? styles.imgContainer : props.agenceImmo ? styles.agenceImmoImage
            : styles.imgContainerHeaderBlock
        } ${props.groupFormHeader ? styles.imgContainerGroupForm : null}`}
    >
      {/* <img src={props.backgroundUrl} className={styles.img} alt="" /> */}
      <Image
        unoptimized
        className={styles.img}
        src={props.backgroundUrl}
        alt={""}
        fill
      />
    </div>
  );
}

export default index;
